
export const config = {
    PRODUCT_URL: 'https://scanner-api-gk.mysz.io/api/v1/',
    USER_URL: 'https://api.mysz.io/api/v1/',
    REACT_APP_AVATAR_URL: 'https://360olga.s3.eu-west-1.amazonaws.com/index.html'
}